import { 
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { useState, useCallback } from "react";
import { Box, Typography, Card, CardContent, } from '@mui/material';


const Home = ({ lang, onLangChange }) => {
    return (
        <Box
            sx={{
                width: '100vw',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
                padding: 2,
            }}
        >
            <Card
                sx={{
                    maxWidth: 600,
                    width: '100%',
                    boxShadow: 3,
                    borderRadius: 2,
                }}
            >
                <CardContent sx={{ textAlign: 'center' }}>
                    <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', marginBottom: 3 }}>
                        HNO-Praxis
                    </Typography>

                    <Typography variant="h6" component="h2" gutterBottom sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                        Dr. med. Katharina Petri
                    </Typography>

                    <Typography variant="body1" gutterBottom sx={{ marginBottom: 2 }}>
                        befindet sich ab dem 15.01.2026 im HNO-Zentrum Rhein Neckar
                    </Typography>

                    <Typography variant="body2" gutterBottom sx={{ marginBottom: 1 }}>
                        <strong>Max-Josephs-Str. 1, 68167 Mannheim</strong>
                    </Typography>

                    <Typography variant="body2" gutterBottom sx={{ marginBottom: 1 }}>
                        Tel. Praxis: <a href="tel:+491522 3084674" style={{ color: 'inherit', textDecoration: 'none' }}>01522 3084674</a>
                    </Typography>

                    <Typography variant="body2" gutterBottom sx={{ marginBottom: 1 }}>
                        Mobil: <a href="tel:+491733420225" style={{ color: 'inherit', textDecoration: 'none' }}>0173 3420225</a>
                    </Typography>

                    <Typography variant="body2" sx={{ marginBottom: 2, color: 'primary.main' }}>
                        <a href="mailto:praxis.ma2@hno-zentrum-rheinneckar.de" style={{ color: 'inherit', textDecoration: 'none' }}>praxis.ma2@hno-zentrum-rheinneckar.de</a>
                    </Typography>
                <Box sx={{ marginTop: 3 }}>
                    <img 
                        src="https://quickchart.io/qr?text=https://scanned.page/p/2BmMc3" 
                        alt="QR Code"
                        style={{ width: 120, height: 120 }}
                    />
                </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

const App = () => {
  const [lang, setLang] = useState('en');
  const handleLangChange = useCallback((newLang) => {
    setLang(newLang);
  }, []);

  return (
      <Router>
        <Routes>
          <Route path="/" element={<Home lang={lang} onLangChange={handleLangChange} />} />
        </Routes>
      </Router>
  )
}

export default App;